import { useRef } from 'react';
import { useWheelNavigation } from '../hooks/useWheelNavigation';

export const ListModal = ({ activeMenuLevel, parentLevel, masterSearch, setMasterSearch, flatItems, selectedIndex, setSelectedIndex, handleItemSelect, labels }: any) => {
  const isAlteration = activeMenuLevel.startsWith('alteration_');
  const headerText = labels[parentLevel] || parentLevel;
  const titleText = labels[activeMenuLevel] || 'List';
  const modalScrollRef = useRef(null);
  useWheelNavigation(modalScrollRef, flatItems.length, setSelectedIndex, false, () => flatItems && flatItems[selectedIndex] && handleItemSelect(flatItems[selectedIndex], selectedIndex));

  return (
    <div className="absolute inset-0 z-50 flex justify-center items-start bg-[#5a6a6a]/40 backdrop-blur-[2px]">
       <div className="flex flex-col items-center w-[320px]">
          <div className="bg-white border-x border-b border-gray-400 w-full flex flex-col items-center py-2 shadow-sm relative z-10">
             <span className={`font-bold text-[13px] ${isAlteration ? 'underline decoration-gray-400 underline-offset-2' : ''} mb-2 text-black`}>{headerText}</span>
             <input type="text" value={masterSearch} onChange={(e) => setMasterSearch(e.target.value)} className="w-[90%] border border-gray-300 bg-[#eefcfc] px-2 py-0.5 text-[13px] outline-none text-black font-medium focus:border-[#1e8585]" autoFocus />
          </div>
          <div className="bg-[#f8fafc] border border-gray-400 border-t-0 w-full flex flex-col shadow-2xl z-10">
             <div className="bg-[#1e8585] text-white px-2 py-1 text-[13px] font-semibold">{titleText}</div>
             <div ref={modalScrollRef} className="flex flex-col py-1 overflow-y-auto h-[calc(100vh-140px)] scrollbar-thin">
                {flatItems.map((item: any, idx: number) => (
                  <div key={idx} onClick={() => handleItemSelect(item, idx)} className={`px-3 py-[2px] text-[13px] cursor-pointer flex ${item.align === 'right' ? 'justify-end pr-3' : 'justify-start'} ${selectedIndex === idx ? 'bg-[#1e8585] text-white font-bold active-row' : 'text-black'}`}>{item.name}</div>
                ))}
             </div>
          </div>
       </div>
    </div>
  );
};
